/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import {Injectable} from '@angular/core';
import {NbRoleProvider} from './role.provider';
import {NbAclService} from './acl.service';
import {Observable} from 'rxjs/Observable';
import {map} from 'rxjs/operators/map';
import {of} from 'rxjs';
import {PermissionService} from './permission.service';

@Injectable()
export class NbAccessChecker {

  constructor(protected roleProvider: NbRoleProvider,
              protected permissionService: PermissionService,
              public acl: NbAclService) {
  }

  isGranted(permission: string | string[], resource?: string): Observable<boolean> {
    if (resource == null) {
      resource = 'default';
    }
    return this.roleProvider.getRole()
      .pipe(
        map((role: string) => {
          if (this.acl.can(role, 'ALL_ALL', resource))
            return true;
          if (permission instanceof Array) {
            for (let i = 0; i < permission.length; i++) {
              if (!this.acl.can(role, permission[i], resource)) {
                return false;
              }
            }
            return true;
          } else {
            return this.acl.can(role, permission, resource);
          }
        }));
  }

  private getRole(): Observable<string> {
    const role: string = this.permissionService.getCurrentUserRole();
    return of(role);
  }

}
